// Selo da situação de uma delegação (Parte 5.5): rótulo de `authz:delegations.status.*` e variante por situação (`delegationStatusVariant`);
// `Scheduled` é a ativa cuja vigência ainda não começou.
import { Badge } from '@giyus/ui';
import { useTranslation } from 'react-i18next';

import type { Delegation } from '../../api/delegations';
import { delegationStatusVariant, displayStatus } from '../delegationModel';

export interface DelegationStatusBadgeProps {
  readonly delegation: Pick<Delegation, 'status' | 'effectiveStatus'>;
  readonly testId?: string | undefined;
}

export function DelegationStatusBadge({ delegation, testId }: DelegationStatusBadgeProps) {
  const { t } = useTranslation('authz');
  const status = displayStatus(delegation);
  return (
    <Badge variant={delegationStatusVariant(status)} data-testid={testId} data-status={status}>
      {t(`delegations.status.${status}`, { defaultValue: status })}
    </Badge>
  );
}
